// "Frequently bought together" box from the Essential Upsell app: the whole card toggles, a ticked extra follows the shopper's size,
// and a bundle add gets the theme's usual "added to cart" popdown.
(() => {
  const SIZES = { xs: 'xs', xsmall: 'xs', s: 's', small: 's', m: 'm', medium: 'm', l: 'l', large: 'l', xl: 'xl', xlarge: 'xl', '2xl': '2xl', xxl: '2xl', xxlarge: '2xl', '3xl': '3xl', xxxl: '3xl', xxxlarge: '3xl' };
  const sizeKey = (value) => {
    const key = value.toLowerCase().replace(/[\s-]/g, '');
    return SIZES[key] || key;
  };
  const parts = (option) => option.textContent.split('/').map((part) => part.trim());
  const boxOf = (element) => element.closest('form > [data-essential-upsell-element="container"]');
  const extrasTicked = (box) => box.querySelectorAll('input[type="checkbox"]:checked:not(:disabled)').length;

  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-essential-upsell-element="product"]');
    if (!card || !boxOf(card) || event.target.closest('input, select, a, button')) { return; }
    const checkbox = card.querySelector('input[type="checkbox"]');
    if (checkbox && !checkbox.disabled) { checkbox.click(); }
  });

  // The app swallows its own click events, so catch them on the way down and act once the app has run.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.matches('input[type="checkbox"]') && boxOf(target)) { setTimeout(() => matchSize(target)); }
    const button = target.closest('[data-essential-upsell-element="add-to-cart-button"]');
    if (button && !button.disabled && boxOf(button)) { watchAdd(boxOf(button), extrasTicked(boxOf(button)) + 1); }
  }, true);

  // The app also fires a popdown with no product, which would wipe the real one.
  window.addEventListener('theme:cart:popdown', (event) => {
    if (!event.detail || !event.detail.variant || !event.detail.variant.id) { event.stopImmediatePropagation(); }
  }, true);

  function matchSize(checkbox) {
    if (!checkbox.checked) { return; }
    const box = boxOf(checkbox);
    const mainSelect = box && box.querySelector('[data-essential-upsell-element="product"] select');
    const select = checkbox.closest('[data-essential-upsell-element="product"]').querySelector('select');
    if (!mainSelect || !select || select === mainSelect) { return; }

    const size = sizeKey(parts(mainSelect.selectedOptions[0]).pop());
    const current = parts(select.selectedOptions[0]);
    const options = [...select.options].filter((option) => sizeKey(parts(option).pop()) === size);
    // Keep the extra's colour where that colour comes in the size, otherwise take the size in any colour.
    const match = options.find((option) => parts(option).slice(0, -1).join('/') === current.slice(0, -1).join('/')) || options[0];
    if (!match || match.selected) { return; }
    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // The app clears the ticks once its add succeeds, which is the only signal it gives.
  function watchAdd(box, count) {
    const mainSelect = box.querySelector('[data-essential-upsell-element="product"] select');
    const variantId = mainSelect && Number(mainSelect.value);
    let tries = 0;
    const check = () => {
      if (extrasTicked(box) && tries < 30) { tries += 1; setTimeout(check, 200); return; }
      if (tries >= 30) { document.dispatchEvent(new CustomEvent('upsell:add-failed')); return; }
      fetch(`${window.theme.routes.cart}.js`).then((response) => response.json()).then((cart) => {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        if (variantId) { document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: { id: variantId } }, bubbles: true })); }
        document.dispatchEvent(new CustomEvent('upsell:added', { detail: { count: count } }));
      }).catch(() => document.dispatchEvent(new CustomEvent('upsell:add-failed')));
    };
    setTimeout(check, 200);
  }

  // Heading and group roles so screen readers hear what the ticks belong to.
  const label = () => {
    document.querySelectorAll('form > [data-essential-upsell-element="container"]').forEach((box, index) => {
      const title = box.querySelector(':scope > [data-essential-upsell-element="header"] [data-essential-upsell-element="title"]');
      if (!title || box.getAttribute('role') === 'group') { return; }
      title.id = title.id || `UpsellBoxTitle-${index}`;
      title.setAttribute('role', 'heading');
      title.setAttribute('aria-level', '2');
      box.setAttribute('role', 'group');
      box.setAttribute('aria-labelledby', title.id);
    });
  };
  // The app renders its box inside the product form after load.
  document.querySelectorAll('form[data-product-form]').forEach((form) => new MutationObserver(label).observe(form, { childList: true, subtree: true }));
  label();
})();
